import React          from 'react';
import PropTypes      from 'prop-types'
import RadioComponent from 'pu-react/components/base/RadioComponent';

const HasArray = (props) => {
  // const name = 'has_array';
  const { onChangeParameter, parameters } = props
  return (
    <div className="has-array-section itv">
      <strong className="title">I would like to receive my PCBs as</strong>
      <div className="row g-0 has-array">
        <div className="col-12">
          <RadioComponent
            name="has_array"
            label="Individual Boards"
            value="0"
            checked={parameters.has_array === '0'}
            onChange={e => onChangeParameter('has_array', e.target.value)}
            className="individually"
            inputClassName="has-array-no"
            inputId="has-array-no"
            groupName={props.groupName} />
        </div>
        <div className="col-sm-6 col-lg-12 col-xl-6">
          <RadioComponent
            name="tab_route_panels"
            label="Tab Routed Panels"
            value="1"
            checked={parameters.has_array === '1' && parameters.tab_rout === '1'}
            onChange={() => onChangeParameter('tab_route_panels', '1')}
            className="tab-routed-panel"
            inputClassName="has-array-yes-tab-route"
            inputId="has-array-yes-tab-route"
            groupName={props.groupName}/>
        </div>
        <div className="col-sm-6 col-lg-12 col-xl-6 ps-xl-2 ">
          <RadioComponent
            name="v_score_panels"
            label="V-Score Panels"
            value="1"
            checked={parameters.has_array === '1' && parameters.scoring === '1'}
            onChange={() => onChangeParameter('v_score_panels', '1')}
            className="v-scored-panels"
            inputClassName="has-array-yes-scoring"
            inputId="has-array-yes-scoring"
            groupName={props.groupName} />
        </div>
      </div>
    </div>
  );
};

HasArray.propTypes = {
  groupName: PropTypes.string,
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
};

export default HasArray;
